import { Module, VuexModule, Mutation, Action, getModule } from "vuex-module-decorators"
import store from 'Store/store'; //IMPORTANT: use current store - else we cannot track it in the vue tools in chrome
import ApiProvider from "Api/ApiProvider";
import { ScannedBarcode} from "Api/CoreApi";
import Vue from "Vue";

@Module({ dynamic: true, store, name: 'barcodestore', namespaced: true })
export class BarcodeStoreModule extends VuexModule {
    
    private  _barcodeList: ScannedBarcode[] = [];
    
    public get barcodeList(): ScannedBarcode[]{
        return this._barcodeList;
    }
    
    @Action({rawError: false, commit: 'updateList'})
    public updateValue(value: {index: number, item: ScannedBarcode}){
        this._barcodeList[value.index] = value.item;
        return this._barcodeList;
    }
    
    @Action({rawError: false, commit: 'updateList'})
    public add(value: ScannedBarcode = <ScannedBarcode>{}){
        this._barcodeList.push(value);
        return this._barcodeList;
    }
    
    @Action({rawError: false, commit: 'updateList'})
    public remove(removeIndex: number){        
        return this._barcodeList.filter((value: ScannedBarcode, index: number) => index != removeIndex);
    }
    @Mutation
    clearList(){
        //deep clone to avoid re-fresh issues on "complex" types such as 'enum'
        this._barcodeList = [].slice();
        console.log(this._barcodeList);
        
    }
    
    @Mutation
    updateList(barcodes: ScannedBarcode[]){
        
        //deep clone to avoid re-fresh issues on "complex" types such as 'enum'
        Vue.set(this, '_barcodeList', barcodes);
        
        
        //this._barcodeList = barcodes.slice(); 
    }
    
}
export default getModule(BarcodeStoreModule);